<template>
  <div v-if="visible" class="custom-dialog-overlay" @click="handleOverlayClick">
    <div class="custom-dialog-box" @click.stop>
      <div class="custom-dialog-content">
        <p>{{ message }}</p>
      </div>
      <div class="custom-dialog-actions">
        <button
          v-if="type === 'confirm'"
          class="dialog-btn cancel-btn"
          @click="handleCancel"
        >
          {{ cancelText }}
        </button>
        <button class="dialog-btn confirm-btn" @click="handleConfirm">
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/utils/i18n";

export default {
  name: "CustomDialog",
  data() {
    return {
      visible: false,
      message: "",
      type: "alert", // 'alert' or 'confirm'
      resolve: null,
      currentLanguage: "ja",
    };
  },
  created() {
    // 设置初始语言
    this.currentLanguage = i18n.getLanguage();
    // 监听语言变化
    window.addEventListener("languageChanged", this.updateLanguage);
  },
  beforeDestroy() {
    window.removeEventListener("languageChanged", this.updateLanguage);
  },
  computed: {
    cancelText() {
      return this.currentLanguage === 'ja' ? 'キャンセル' : 'Cancel';
    },
    confirmText() {
      return this.currentLanguage === 'ja' ? '確認' : 'Confirm';
    }
  },
  methods: {
    updateLanguage() {
      this.currentLanguage = i18n.getLanguage();
      this.$forceUpdate();
    },
    show(message, type = "alert") {
      this.message = message;
      this.type = type;
      this.visible = true;

      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    handleConfirm() {
      this.visible = false;
      if (this.resolve) {
        this.resolve(true);
      }
    },
    handleCancel() {
      this.visible = false;
      if (this.resolve) {
        this.resolve(false);
      }
    },
    handleOverlayClick() {
      if (this.type === "alert") {
        this.handleConfirm();
      }
    },
  },
};
</script>

<style scoped>
.custom-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 9999;
  padding-top: 0;
  pointer-events: none;
}

.custom-dialog-box {
  background: white;
  border-radius: 8px;
  min-width: 300px;
  max-width: 500px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  animation: slideDown 0.2s ease-out;
  border: 1px solid #d3d3d3;
  pointer-events: auto;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.custom-dialog-content {
  padding: 20px 20px 15px 20px; /* 缩小上下内边距 */
  text-align: center;
}

.custom-dialog-content p {
  margin: 0;
  font-size: 14px;
  color: #333;
  line-height: 1.4; /* 缩小行高 */
  word-break: break-word;
}

.custom-dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 0 20px 15px 20px; /* 缩小下内边距 */
  border-top: 1px solid #e0e0e0;
  padding-top: 10px; /* 缩小上内边距 */
}

.dialog-btn {
  padding: 8px 24px;
  border: 1px solid #d3d3d3;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
  min-width: 70px;
  background: #f5f5f5;
  color: #333;
}

.dialog-btn:hover {
  background: #e8e8e8;
}

.confirm-btn {
  background: #4d90fe;
  color: white;
  border-color: #4d90fe;
  border-radius: 6px;
}

.confirm-btn:hover {
  background: #357ae8;
  border-color: #357ae8;
}

.cancel-btn {
  background: #f5f5f5;
  color: #333;
  border-color: #d3d3d3;
  border-radius: 6px;
}

.cancel-btn:hover {
  background: #e8e8e8;
}
</style>
